import { z } from 'zod';

/**
 * The build-time configuration, validated once at module load.
 *
 * Vite inlines every `VITE_*` variable into the bundle at build time — there is
 * no process to read them from at runtime — so these are decided when the app is
 * built, per environment, by `scripts/deploy.sh`. Everything here is public by
 * construction: it ships in JavaScript the browser can read. Nothing secret may
 * be added to this file.
 *
 * (They were `NEXT_PUBLIC_*` under Next, which meant the same thing.)
 */
const envSchema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_SITE_URL: z.string().url(),
  VITE_FIREBASE_API_KEY: z.string().min(1),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().min(1),
  VITE_FIREBASE_PROJECT_ID: z.string().min(1),
});

/*
 * A missing or malformed value is fatal, in every environment.
 *
 * This used to fall back to a hardcoded Firebase project when the variables
 * were absent or failed to parse, which meant a mis-configured build did not
 * fail — it started, and pointed sign-in at somebody else's project. The
 * failure it was protecting against (a fresh checkout with no .env.local) is
 * better served by a message naming the file to create.
 */
function readEnv() {
  const parsed = envSchema.safeParse(import.meta.env);
  if (parsed.success) return parsed.data;

  const missing = parsed.error.issues.map((issue) => issue.path.join('.')).join(', ');
  throw new Error(
    `Admin config is incomplete (${missing}). ` +
      'Copy apps/admin/.env.staging.example to apps/admin/.env.local, ' +
      'or run ./scripts/stack.sh start:staging from the repo root.',
  );
}

export const env = readEnv();
